export const PaymentMethods = Object.freeze({
  CREDIT_CARD: "CREDIT_CARD",
  FACE_TO_FACE: "FACE_TO_FACE",
  PIX: "PIX"
});
